import React from "react";
import './Home.scss';
import tobogan from '../../assets/illustration/tobogan.png';
import home2 from '../../assets/illustration/home2.png';


class Home extends React.Component {
    render(){
        return (
            <div className="home-wrapper">
               <div className="home-content">
                   <div>
                       <img className="illustration" src={tobogan} alt=""/>
                   </div>
                   <div>
                       <img className="illustration2" src={home2} alt=""/>
                   </div>
               </div>
            </div>
        )
    }
}

export default Home;